export const getKeyStartsWithNegative = (str: string): [string, boolean] => {
  const startsWithNegative = str.startsWith('-');
  const key = startsWithNegative ? str.slice(1) : str;

  return [key, startsWithNegative];
};
